import React from "react";
import Link from "../global/Link";

export const FooterMenu = ({menu}) => {

  return menu?.length > 0 && (
    <nav className="footer-menu fs-7 mb-6 mb-lg-0">
      <ul className="list-unstyled mb-6">
        {menu.map((item, index) => (
          <li key={`${item.id + index}`} className={index === 0 ? `mb-4` : 'mb-3'}>
            {item.target === '_blank' ?
              <a className="d-inline-flex align-items-start" target="_blank" rel="noopener noreferrer" href={item.url}>
                <svg className="me-2" width={16} height={16}><use xlinkHref="#icon-external"/></svg>{item.label}
              </a>
              :
              <Link to={item.url}>{item.label}</Link>
            }
            {item.children && item.children.length > 0 && (
              <ul className="list-unstyled ps-3 sub-nav-level-2 pb-lg-1 mt-3">
                {item.children.map((grandChildrenItem, index) => (
                  <li key={grandChildrenItem.id + index} className="mt-3">
                    <Link className="nav-link sub-nav-link"
                          to={grandChildrenItem.url}
                          target={grandChildrenItem.target || '_self'}>{grandChildrenItem.label}</Link>
                  </li>
                ))}
              </ul>
            )}
          </li>
        ))}
      </ul>
    </nav>
  )
}
